module.exports = __webpack_public_path__ + "static/media/motherboard_3x3-solid.2beae6dd.svg";